import Script from 'next/script'
import { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'

export const PricePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Stock Price Information"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <iframe
        id="irpocket-stock-chart-pc"
        src="//irpocket.com/stock-chart/141A_en.html"
        width="100%"
        height="920"
      ></iframe>
      <Script src="//irpocket.com/stock-chart/assets/javascript/141A/resize.js" />
      {/* <iframe
        id="irpocket-stock-chart-pc"
        src="//irpocket.com/stock-chart/5882_en.html"
        width="100%"
        height="920"
      ></iframe>
      <Script src="//irpocket.com/stock-chart/assets/javascript/5882/resize.js" /> */}
    </Layout>
  )
}

PricePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir' },
    { name: 'Stock Information', path: '/en/ir/stock' },
    { name: 'Stock Price Information', path: '' },
  ]

  return (
    <>
      <Head
        title="Stock Price Information"
        description="The share price chart."
        ogp={{ url: 'en/ir/stock/price' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
